import { Row, Col } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import ExportAsset from "@/components/Export/ExportAsset";
import ExportAssetType from "@/components/Export/ExportAssetType";
import ExportCard from "@/components/Export/ExportCard";
import ExportDataset from "@/components/Export/ExportDataset";
import ExportIntervention from "@/components/Export/ExportIntervention";
import ExportLocation from "@/components/Export/ExportLocation";
import BaseHeader from "@/components/Header/BaseHeader";
import InsertCard from "@/components/Import/InsertCard";
import UpdateCard from "@/components/Import/UpdateCard";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";

import SelectModelForm from "./SelectModelForm";

const ImportTool = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [activeModel, setActiveModel] = useState(searchParams.get("model"));
  const [selectedTemplateId, setSelectedTemplateId] = useState(
    searchParams.has("template") ? parseInt(searchParams.get("template")) : null
  );

  const isImportToolReady =
    activeModel === "dataset" ? !!selectedTemplateId : !!activeModel;

  const handleActiveModelChange = (value) => {
    setActiveModel(value);
    searchParams.set("model", value);
    searchParams.delete("template");
    setSearchParams(searchParams);
  };

  const handleTemplateChange = (value) => {
    setSelectedTemplateId(value);
    if (value) {
      searchParams.set("template", value);
    } else {
      searchParams.delete("template");
    }
    setSearchParams(searchParams);
  };

  return (
    <>
      <BaseHeader title={t("navigation:import")} />
      <AppLayoutPage>
        <Row justify="left">
          <Col span={12}>
            <SelectModelForm
              activeModel={activeModel}
              selectedTemplateId={selectedTemplateId}
              onActiveModelChange={handleActiveModelChange}
              onTemplateChange={handleTemplateChange}
            />
          </Col>
          <hr style={{ width: "100%", marginTop: 0, marginBottom: "30px" }} />
        </Row>

        {isImportToolReady && (
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={12} xl={8}>
              <ExportCard activeModel={activeModel}>
                {activeModel === "location" && <ExportLocation />}
                {activeModel === "asset" && <ExportAsset />}
                {activeModel === "assetType" && <ExportAssetType />}
                {activeModel === "intervention" && <ExportIntervention />}
                {activeModel === "dataset" && (
                  <ExportDataset selectedTemplateId={selectedTemplateId} />
                )}
              </ExportCard>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={8}>
              <InsertCard
                model={`${activeModel}s`}
                modelName={t(`global:${activeModel}Plural`)}
                selectedTemplateId={selectedTemplateId}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={8}>
              <UpdateCard
                model={`${activeModel}s`}
                modelName={t(`global:${activeModel}Plural`)}
              />
            </Col>
          </Row>
        )}
      </AppLayoutPage>
    </>
  );
};

export default ImportTool;
